'use strict';

var Range = require('./internal/Range'),
    rangeClamp = require('./internal/rangeClamp'),
    defineOnPrototype = require('../common/internal/defineOnPrototype');

defineOnPrototype(Range, {

  'clamp': function(obj) {
    return rangeClamp(this, obj);
  }

});

// This package does not export anything as it is
// simply defining "clamp" on Range.prototype.


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/range/clamp.js
// module id = 385
// module chunks = 0